import { QueryParamsConst } from '../../../constants/query-params.constants';
import { updateSearchResults } from '../../../hooks/useQueryParams.effect';
import { TBaseObj, TIconFromRenderingParams } from '../../../types/types';
import { TBrochureCardField, TDownloadBrochureFields, TDownloadBrochuresProps } from '../types/downloadBrochures.types';

export class DownloadBrochureListingModel {
  private readonly fields: TDownloadBrochureFields;

  constructor(props: TDownloadBrochuresProps) {
    this.fields = props.fields;
  }

  get isUnreleased(): boolean | undefined {
    return !!this.fields?.isComponentUnreleased;
  }

  get contextItemUrl(): string {
    return this.fields?.itemData?.contextItemUrl || '';
  }

  get icon(): TIconFromRenderingParams[] {
    return this.fields?.itemData?.iconsList || [];
  }

  get brochureCards(): TBrochureCardField[] {
    return this.fields?.apiData?.items || [];
  }

  get filters() {
    return this.fields?.apiData?.filters || [];
  }

  get totalNumberOfCards(): number {
    return this.fields?.apiData?.totalSearchResults || 0;
  }

  findFilterByName(filterName) {
    return this?.filters.find((filter) => filter.filterType === filterName) || {};
  }

  resetFilter(navigate) {
    updateSearchResults(navigate, {
      [QueryParamsConst.PAGE]: '',
      [QueryParamsConst.CATEGORIES]: '',
      [QueryParamsConst.LINE]: '',
      [QueryParamsConst.SERIES]: '',
    });
  }

  resetSearch(navigate) {
    updateSearchResults(navigate, {
      [QueryParamsConst.PAGE]: '',
      [QueryParamsConst.SEARCH_BROCHURE]: '',
      [QueryParamsConst.SEARCH_BROCHURE_ID]: '',
    });
  }

  updateQueryByKey(navigate, key, val) {
    const resetPage = key != QueryParamsConst.PAGE;

    const keyValues = resetPage
      ? {
          [QueryParamsConst.PAGE]: '',
          [key]: val || '',
        }
      : {
          [key]: val || '',
        };

    updateSearchResults(navigate, keyValues);
  }

  updateQueryByBulkKeys(navigate, obj: TBaseObj) {
    updateSearchResults(navigate, obj);
  }
}
